module.exports = __webpack_public_path__ + "img/eQzfSdkP.504b04bd.svg";